<template>
    <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" :destroyOnClose="true"
        :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
        <div class="drawer-box" style="width: 100%;height: 100%">
            <section>
                <h4><b>导入数据</b></h4>
                <a-table :columns="tableColumns" :loading="tableLoading" :data-source="tableData" row-key="id" bordered
                    :pagination="false" :scroll="{ x: scrollX, y: 500 }">
                    <template slot="evaluateValue" slot-scope="text, record">
                        <cell-editor :len="2" :item="record" name="evaluateValue"
                        @blur="target => tableItemUpdate(target, record.id)" :text="text"
                        :actions="tableItemUpdateSave" />
                    </template>
                </a-table>
            </section>
            <section style="margin: 12px 0;">
                <h4><b>预览计算结果</b></h4>
                <div>
                    <a-select disabled v-model="equation" allowClear style="width: 250px;" :options="equationList"
                        placeholder="请选择方程">
                    </a-select>
                    <a-button :disabled="!equation" :loading="calcFormualLoading" type="primary"
                        style="margin-left: 1em;padding: 0 1.4em;" @click="previewCalcResult">预览计算结果</a-button>
                </div>
                <a-table style="margin-top: 12px;" v-show="calcResultVisible" :columns="calcResultTableColumns" bordered
                    :data-source="calcResult" :pagination="false" :scroll="{ x: scrollX, y: 500 }">
                    <div slot="difference" slot-scope="t,record">
                        <span
                            v-if="(Number(((record.culationValue || 0) - (record.nutritionValue || 0)).toFixed(2)) === 0) || (!record.nutritionValue && !record.culationValue)">
                            -
                        </span>
                        <span v-else>
                            {{ ((record.culationValue || 0) - (record.nutritionValue || 0)).toFixed(2) }}
                        </span>
                    </div>
                    <span slot="culationValue" slot-scope="t">
                        {{ t || t === 0 ? t.toFixed(2) : '' }}
                    </span>
                    <span slot="nutritionValue" slot-scope="t">
                        {{ t || t === 0 ? t.toFixed(2) : '' }}
                    </span>
                </a-table>
            </section>
        </div>

        <template #title>
            <b>{{ title }}</b>
        </template>
    </a-drawer>
</template>

<script>
import CellEditor from '../editor/CellEditor.vue';
const tableColumns = [
    {
        title: "指标名称",
        align: 'center',
        dataIndex: "nutritionName",
        width: 100,
    },
    {
        title: "指标全称",
        align: 'center',
        dataIndex: "nutritionFullName",
        ellipsis: true,
        width: 80,
    },
    {
        title: "代码",
        align: 'center',
        dataIndex: "nutritionCode",
        width: 80,
        ellipsis: true,
    },
    {
        title: "单位",
        align: 'center',
        dataIndex: "nutritionUnit",
        width: 80,
        ellipsis: true,
    },
    {
        title: "评估数值",
        align: 'center',
        dataIndex: "evaluateValue",
        ellipsis: true,
        width: 80,
        scopedSlots: { customRender: 'evaluateValue' },
    },
    {
        title: "营养分析",
        align: 'center',
        dataIndex: "nutritionAnalysisVal",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            return text ? text.toFixed(2) : '';
        }
    },
    {
        title: "差异",
        align: 'center',
        dataIndex: "diffVal",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            return text ? text.toFixed(2) : '';
        }
    }
];
const calcResultTableColumns = [
    {
        title: "指标名称",
        align: 'center',
        width: 160,
        dataIndex: "name",
    },
    {
        title: "指标全称",
        align: 'center',
        dataIndex: "fullName",
    },
    {
        title: "代码",
        align: 'center',
        dataIndex: "code",
    },
    {
        title: "单位",
        align: 'center',
        dataIndex: "unit",
    },
    {
        title: '原先值',
        align: 'center',
        dataIndex: 'nutritionValue',
        width: 120,
        ellipsis: true,
        scopedSlots: { customRender: 'nutritionValue' },
        sorter: (a, b) => a.nutritionValue - b.nutritionValue,
    },
    {
        title: '计算值',
        align: 'center',
        dataIndex: 'culationValue',
        width: 120,
        ellipsis: true,
        scopedSlots: { customRender: 'culationValue' },
        sorter: (a, b) => a.culationValue - b.culationValue,
    },
    {
        title: '差异',
        align: 'center',
        dataIndex: 'difference',
        width: 120,
        ellipsis: true,
        scopedSlots: { customRender: 'difference' },
        sorter: (a, b) => Number((a.culationValue || 0) - (a.nutritionValue || 0)) - Number((b.culationValue || 0) - (b.nutritionValue || 0)),
    },
];

export default {
    components: {
        CellEditor
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rawId: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '指标维护'
        },
        taskId: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            wrapStyle: {
                overflow: 'hidden'
            },
            bodyStyle: {
                overflow: 'hidden',
            },
            drawerWidth: 1000,
            scrollX: 940,
            tableLoading: false,
            tableColumns,
            tableData: [],

            equation: undefined,
            equationList: [], // 方程列表
            calcFormualLoading: false,
            calcResultTableColumns,
            calcResult: [],
            calcResultVisible: false,
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.getRawDetail();
                if (!this.equation) {
                    this.getFormulaData();
                }
            }
        },
    },
    mounted() {
        const viewportWidth = window.innerWidth;
        const _width = viewportWidth * 0.8;
        if (_width < 1000) {
            this.drawerWidth = _width;
            this.scrollX = _width - 60;
        }
    },
    methods: {
        getRawDetail() {
            const data = {
                rawId: this.rawId,
                supplierRawId: this.id,
                factoryId: window.localStorage.getItem("factoryId"),
                taskId: this.taskId,
            };
            this.tableLoading = true;
            this.$post('/nhf-app/supplierrawnutrition/getSupplierRawNutritionListVO', data).then(res => {
                if (res.success) {
                    this.tableData = res.data;
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        tableItemUpdate(item, id) {
            const list = [...this.tableData];
            const targets = list.filter(item => id === item.id)[0];
            if (targets) {
                Object.assign(targets, item);
                this.tableData = list;
            }
        },
        tableItemUpdateSave(item) {
            const data = {
                "evaluateValue": item.evaluateValue,
                "id": item.id
            };
            return this.$post('/nhf-app/supplierrawnutrition/updateSupplierRawNutrition', data);
        },
        // 获取底部选择框选项
        getFormulaData() {
            this.$http.get('/nhf-fine/equation/list').then(res => {
                let { success, data } = res;
                if (success) {
                    this.equationList = data.map(item => ({ value: item.id, label: item.name })) || [];
                    if (this.equationList.length > 0) {
                        this.equation = this.equationList.find(item => item.label === 'CVB+新希望六和方程体系')?.value;
                    }
                }
            });
        },
        previewCalcResult() {
            const data = {
                factoryId: window.localStorage.getItem("factoryId"),
                rawId: this.rawId,
                equationId: this.equation,
                taskId: this.taskId,
                supplierRawId: this.id,
            };
            this.calcFormualLoading = true;
            this.$post("/nhf-app/supplierrawnutrition/supplierRawEquationCalculateView", data)
                .then((res) => {
                    let { success } = res;
                    if (success) {
                        this.calcResult = res.data;
                        this.calcResultVisible = true;
                    } else {
                        this.$message.warning("指标数值异常，请修改后再计算。");
                    }
                })
                .finally(() => {
                    this.calcFormualLoading = false;
                });
        },
        onClose() {
            this.$emit('close');
            this.tableData = [];
            this.calcResultVisible = false;
            this.calcResult = [];
        },
    }
};
</script>


<style lang="scss" scoped>
.containers {
    width: 100%;
    flex: 1;
    height: calc(100vh - 100px);
}

::v-deep .drawer {
    overflow: hidden;

    .ant-drawer-wrapper-body,
    .ant-drawer-wrapper-body {
        overflow: hidden;
    }
}

::v-deep .ant-checkbox-wrapper-disabled {
    display: none;
}

footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    border-top: 1px solid #e9e9e9;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ant-btn {
        margin-right: 20px;
        min-width: 60px;
    }

    >div {
        display: flex;
        align-items: center;
    }
}
</style>
